import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Container } from 'uiComponents/settingsContainer'
import Feature from 'features/feature'
import { ActionButtonA } from 'uiComponents/buttons'
import ParkMapProvider from '../context/mapViewer'
import SelectedParkMapProvider from '../context/selectedParkMap'
import { ParkMapPagesParams } from '../paths'
import { useListParkMapQuery } from '../reduxQuery'
import BaseKnowledgeLink from 'uiComponents/typography/BaseKnowledgeLink'
import VenueSectionTabs from 'venue/sectionTabs'
import { NavigationBack } from 'uiComponents/navigation/navigationBack'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'
import './styles.scss'
import { useTranslation } from 'translations'

const ParkMapsContainer: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<ParkMapPagesParams>()
    const { data } = useListParkMapQuery({ slug: accountSlug })
    const parkmaps = data ?? []
    const location = useLocation()
    const history = useHistory()
    const isMapDetailPage = ['details', 'styles', 'cat_poi'].some((path) => location.pathname.includes(path))

    return (
        <SelectedParkMapProvider>
            <ParkMapProvider>
                <div style={{ position: 'relative' }} id="park-map">
                    {isMapDetailPage ? (
                        <InSectionTabsSlot>
                            <div className="detail-page-back">
                                <NavigationBack
                                    onClick={() => history.push(`/account/${accountSlug}/venue/park_map`)}
                                    text="Back to park maps"
                                />
                            </div>
                        </InSectionTabsSlot>
                    ) : (
                        <VenueSectionTabs />
                    )}
                    <Feature name="parkMap">
                        <div className="park-map-header">
                            {parkmaps.length > 0 && !isMapDetailPage && (
                                <ActionButtonA
                                    size="medium"
                                    href={`/account/${accountSlug}/venue/park_map/create/details`}
                                    kind="action"
                                >
                                    {t('venue.parkMap.container.addNew')}
                                </ActionButtonA>
                            )}
                        </div>
                        <Container style={{ marginBottom: 0 }}>{children}</Container>
                    </Feature>
                    <BaseKnowledgeLink link="https://support.convious.com/help/park-map-configurator-31b8cc3f" />
                </div>
            </ParkMapProvider>
        </SelectedParkMapProvider>
    )
}

export default ParkMapsContainer
